"use client";
import { IBrands } from "@/api/AppApi/services/home/interfaces/IBrands";
import Brand from "./Brand";
import { useIsMobile } from "@/hooks/useIsMobile";
import EmblaSlider from "../../lib/Embla-slider";
import { TSlideWidith } from "../../lib/Embla-slider/EmblaSliderContainer";
import useIsClient from "@/hooks/useIsClient";

const BrandsCarousel: React.FC<IBrands> = (props) => {
  const isClient = useIsClient();
  const mobile = useIsMobile();

  const config = {
    width: 170,
    width_mobile: 120,
    gap: 16,
    gap_mobile: 8,
  };

  const slideWidth = mobile ? config.width_mobile : config.width;

  const slideGap = mobile ? config.gap_mobile : config.gap;

  if (!isClient) {
    return (
      <div
        className="skeleton-rect"
        style={{
          width: "100%",
          paddingTop: "96px",
        }}
      />
    );
  }

  return (
    <div className="brands">
      <EmblaSlider>
        <EmblaSlider.EmblaSliderViewport>
          <EmblaSlider.EmblaSliderContainer
            gap={slideGap}
            slides={[
              ...(props.data?.map((brand) => ({
                component: (
                  <div style={{ width: slideWidth }}>
                    <Brand key={brand.id} {...brand} />
                  </div>
                ),
                width: "auto" as TSlideWidith,
              })) || []),
            ]}
          />
          <EmblaSlider.EmblaFilters />
          <EmblaSlider.EmblaSliderPrevNextButtons />
        </EmblaSlider.EmblaSliderViewport>
      </EmblaSlider>
    </div>
  );
};

export default BrandsCarousel;
